import React from 'react';
import {Container} from '../../../globalStyles';
import {
TermsSec,
TermsSection,
Heading,
Subtitle,
Subtitleh3,
Text,
Lista,
ListaItem
} from './TermsAndConditionsUsuarios.elements';


const TermsAndConditionsUsuarios = () => {
  return (
    <>
      <TermsSec>
        <Container>

          <TermsSection>
            <Heading>Términos y Condiciones de Uso - Usuarios</Heading>
            <Subtitle><i>Última actualización: 16 de diciembre de 2025</i></Subtitle>

            <Text>Bienvenido a <strong>Kusina</strong>, la plataforma de intermediación de pedidos de comida operada por <strong>KUSINA APP E.I.R.L.</strong>, con RUC N° 20613753983, domiciliada en Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro.</Text>

            <Text>Los presentes Términos y Condiciones de Uso (en adelante, los "Términos") regulan el acceso y uso de la aplicación móvil Kusina, nuestra plataforma web y todos los servicios relacionados (en adelante, la "Plataforma" o el "Servicio") por parte de los usuarios consumidores (en adelante, "Usuario", "Tú" o "Cliente").</Text>

            <Text><strong>IMPORTANTE:</strong> Al descargar, acceder, registrarte o utilizar la Plataforma Kusina, declaras haber leído, comprendido y aceptado estos Términos y Condiciones, así como nuestra Política de Privacidad. Si no estás de acuerdo con estos Términos, por favor abstente de utilizar nuestros servicios.</Text>

            <Text>Estos Términos constituyen un contrato legal vinculante entre tú (el Usuario) y KUSINA APP E.I.R.L. (Kusina).</Text>
          </TermsSection>

          <TermsSection>
            <Heading>1. Información de la Empresa</Heading>
            <Lista>
            <ListaItem><Text><strong>Razón Social:</strong> KUSINA APP E.I.R.L.</Text></ListaItem>
            <ListaItem><Text><strong>Nombre Comercial:</strong> KUSINA APP</Text></ListaItem>
            <ListaItem><Text><strong>RUC:</strong> 20613753983</Text></ListaItem>
            <ListaItem><Text><strong>Tipo de Contribuyente:</strong> Empresa Individual de Responsabilidad Limitada</Text></ListaItem>
            <ListaItem><Text><strong>Domicilio Fiscal:</strong> Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro</Text></ListaItem>
            <ListaItem><Text><strong>Actividad Económica Principal:</strong> Programación Informática (CIIU 6201)</Text></ListaItem>
            <ListaItem><Text><strong>Correo Electrónico:</strong> soporte@kusina.site</Text></ListaItem>
            <ListaItem><Text><strong>Teléfono:</strong> +51 973 834 813</Text></ListaItem>
            <ListaItem><Text><strong>Fecha de Inscripción SUNARP:</strong> 05 de febrero de 2025</Text></ListaItem>
            <ListaItem><Text><strong>Partida Registral:</strong> 15842416</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>2. Definiciones</Heading>
            <Text>Para efectos de estos Términos y Condiciones, se entenderá por:</Text>
            <Lista>
            <ListaItem><Text><strong>Kusina o Plataforma:</strong> La aplicación móvil, sitio web y todos los servicios digitales proporcionados por KUSINA APP E.I.R.L.</Text></ListaItem>
            <ListaItem><Text><strong>Usuario o Cliente:</strong> Persona natural mayor de 18 años que utiliza la Plataforma para realizar pedidos de comida para consumo personal.</Text></ListaItem>
            <ListaItem><Text><strong>Restaurante o Anfitrión:</strong> Establecimiento de comida independiente asociado a la Plataforma que prepara y entrega los pedidos realizados por los Usuarios.</Text></ListaItem>
            <ListaItem><Text><strong>Pedido:</strong> Solicitud de productos alimenticios realizada por el Usuario a través de la Plataforma a un Restaurante específico.</Text></ListaItem>
            <ListaItem><Text><strong>Cuenta:</strong> Perfil personal del Usuario creado en la Plataforma mediante registro.</Text></ListaItem>
            <ListaItem><Text><strong>Servicio o Servicios:</strong> Los servicios de intermediación tecnológica entre Usuarios y Restaurantes proporcionados por Kusina.</Text></ListaItem>
            <ListaItem><Text><strong>Precio del Producto:</strong> Valor establecido por el Restaurante para cada producto alimenticio ofrecido en la Plataforma.</Text></ListaItem>
            <ListaItem><Text><strong>Tarifa de Servicio:</strong> Comisión cobrada por Kusina al Usuario por el uso de la Plataforma para facilitar el pedido.</Text></ListaItem>
            <ListaItem><Text><strong>Costo de Entrega:</strong> Monto cobrado por el servicio de entrega del pedido (si aplica), establecido por el Restaurante o Kusina.</Text></ListaItem>
            <ListaItem><Text><strong>Contenido:</strong> Toda la información, textos, gráficos, imágenes, fotografías, videos, software y cualquier otro material disponible en la Plataforma.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>3. Naturaleza del Servicio</Heading>

            <Subtitle>3.1. Servicio de Intermediación</Subtitle>
            <Text>Kusina es una <strong>plataforma tecnológica de intermediación</strong> que conecta a Usuarios con Restaurantes independientes para facilitar pedidos de comida. Kusina NO es un restaurante, NO prepara alimentos, NO es un servicio de delivery propio y NO actúa como agente, representante o empleador de los Restaurantes.</Text>

            <Subtitle>3.2. Rol de Kusina</Subtitle>
            <Text>El rol de Kusina se limita a:</Text>
            <Lista>
            <ListaItem><Text>Proporcionar la infraestructura tecnológica que permite la comunicación entre Usuarios y Restaurantes.</Text></ListaItem>
            <ListaItem><Text>Facilitar el proceso de pedidos y pagos a través de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Brindar soporte técnico y atención al cliente relacionado con el uso de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Gestionar reclamaciones y mediación entre Usuarios y Restaurantes según estos Términos.</Text></ListaItem>
            </Lista>

            <Subtitle>3.3. Responsabilidad de los Restaurantes</Subtitle>
            <Text>Los Restaurantes asociados son establecimientos <strong>independientes y autónomos</strong> responsables de:</Text>
            <Lista>
            <ListaItem><Text>La preparación de alimentos con estándares de calidad, higiene y salubridad.</Text></ListaItem>
            <ListaItem><Text>El cumplimiento de normativas sanitarias, permisos de funcionamiento y licencias aplicables.</Text></ListaItem>
            <ListaItem><Text>La precisión de la información de productos (ingredientes, alérgenos, precios, disponibilidad).</Text></ListaItem>
            <ListaItem><Text>La calidad, seguridad y correcta manipulación de los alimentos.</Text></ListaItem>
            <ListaItem><Text>El empaque adecuado de los pedidos.</Text></ListaItem>
            <ListaItem><Text>El cumplimiento de los tiempos de entrega estimados.</Text></ListaItem>
            <ListaItem><Text>La entrega del pedido al Usuario (cuando el Restaurante gestione su propia entrega).</Text></ListaItem>
            </Lista>

            <Subtitle>3.4. Relación Contractual</Subtitle>
            <Text>Al realizar un pedido a través de Kusina:</Text>
            <Lista>
            <ListaItem><Text>Se establece una relación contractual directa entre el Usuario y el Restaurante para la compra-venta de productos alimenticios.</Text></ListaItem>
            <ListaItem><Text>Kusina facilita la transacción pero no es parte del contrato de compra-venta entre Usuario y Restaurante.</Text></ListaItem>
            <ListaItem><Text>El Usuario acepta que Kusina actúa únicamente como intermediario tecnológico.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>4. Registro y Cuenta de Usuario</Heading>

            <Subtitle>4.1. Requisitos para el Registro</Subtitle>
            <Text>Para utilizar los Servicios de Kusina, debes:</Text>
            <Lista>
            <ListaItem><Text><strong>Ser mayor de 18 años:</strong> Debes tener capacidad legal para celebrar contratos vinculantes. Si eres menor de edad, necesitas el consentimiento expreso de tus padres o tutores legales.</Text></ListaItem>
            <ListaItem><Text><strong>Proporcionar información veraz:</strong> Toda la información que proporciones durante el registro (nombre, correo electrónico, teléfono, dirección) debe ser exacta, completa y actualizada.</Text></ListaItem>
            <ListaItem><Text><strong>Crear credenciales seguras:</strong> Debes establecer una contraseña segura y única para tu Cuenta.</Text></ListaItem>
            <ListaItem><Text><strong>Aceptar términos:</strong> Debes aceptar expresamente estos Términos y Condiciones y nuestra Política de Privacidad.</Text></ListaItem>
            </Lista>

            <Subtitle>4.2. Proceso de Registro</Subtitle>
            <Text>Puedes registrarte mediante:</Text>
            <Lista>
            <ListaItem><Text><strong>Correo electrónico y contraseña:</strong> Creando una cuenta directamente en la Plataforma.</Text></ListaItem>
            <ListaItem><Text><strong>Redes sociales:</strong> Vinculando tu cuenta de Facebook, Google u otras plataformas autorizadas (sujeto a los permisos que otorgues).</Text></ListaItem>
            <ListaItem><Text><strong>Número de teléfono:</strong> A través de verificación por SMS o WhatsApp.</Text></ListaItem>
            </Lista>
            <Text>Kusina puede solicitar verificación adicional de identidad para prevenir fraudes y garantizar la seguridad.</Text>

            <Subtitle>4.3. Cuenta Personal e Intransferible</Subtitle>
            <Lista>
            <ListaItem><Text>Tu Cuenta es <strong>personal, individual e intransferible</strong>. No puedes compartir, vender, ceder o transferir tu Cuenta a terceros.</Text></ListaItem>
            <ListaItem><Text>Solo puedes tener <strong>una Cuenta activa</strong> por persona. La creación de múltiples cuentas está prohibida salvo autorización expresa de Kusina.</Text></ListaItem>
            <ListaItem><Text>Eres el único responsable de todas las actividades realizadas desde tu Cuenta.</Text></ListaItem>
            </Lista>

            <Subtitle>4.4. Seguridad de la Cuenta</Subtitle>
            <Text>Es tu responsabilidad:</Text>
            <Lista>
            <ListaItem><Text>Mantener la confidencialidad de tu contraseña y credenciales de acceso.</Text></ListaItem>
            <ListaItem><Text>No compartir tu contraseña con terceros.</Text></ListaItem>
            <ListaItem><Text>Notificarnos inmediatamente si detectas acceso no autorizado o uso sospechoso de tu Cuenta (contactar a soporte@kusina.site).</Text></ListaItem>
            <ListaItem><Text>Cerrar sesión al finalizar el uso, especialmente en dispositivos compartidos.</Text></ListaItem>
            <ListaItem><Text>Mantener actualizada la aplicación y tu sistema operativo con parches de seguridad.</Text></ListaItem>
            </Lista>
            <Text>Kusina no será responsable por pérdidas derivadas del uso no autorizado de tu Cuenta debido a tu negligencia en proteger tus credenciales.</Text>

            <Subtitle>4.5. Actualización de Datos</Subtitle>
            <Text>Debes mantener actualizada la información de tu Cuenta (nombre, dirección de entrega, teléfono, correo electrónico). Puedes actualizar tus datos desde la sección "Mi Perfil" o "Configuración" de la aplicación.</Text>

            <Subtitle>4.6. Suspensión y Cancelación de Cuenta</Subtitle>

            <Subtitleh3>4.6.1. Suspensión por parte de Kusina</Subtitleh3>
            <Text>Kusina se reserva el derecho de suspender o cancelar tu Cuenta, de forma temporal o permanente, sin previo aviso y sin responsabilidad, en caso de:</Text>
            <Lista>
            <ListaItem><Text>Violación de estos Términos y Condiciones.</Text></ListaItem>
            <ListaItem><Text>Actividades fraudulentas, ilegales o sospechosas.</Text></ListaItem>
            <ListaItem><Text>Proporcionar información falsa o incompleta.</Text></ListaItem>
            <ListaItem><Text>Uso indebido de la Plataforma o abuso de beneficios y promociones.</Text></ListaItem>
            <ListaItem><Text>Conducta abusiva, amenazante o irrespetuosa hacia otros usuarios, Restaurantes o personal de Kusina.</Text></ListaItem>
            <ListaItem><Text>Incumplimiento de pagos o chargebacks (contracargos) fraudulentos.</Text></ListaItem>
            <ListaItem><Text>Sospecha razonable de actividades que perjudiquen a la Plataforma, otros usuarios o Restaurantes.</Text></ListaItem>
            <ListaItem><Text>Inactividad prolongada (más de 24 meses sin uso).</Text></ListaItem>
            </Lista>

            <Subtitleh3>4.6.2. Cancelación por parte del Usuario</Subtitleh3>
            <Text>Puedes cancelar tu Cuenta en cualquier momento desde la configuración de la aplicación o contactando a soporte@kusina.site. Ten en cuenta que:</Text>
            <Lista>
            <ListaItem><Text>La cancelación no exime del cumplimiento de obligaciones pendientes (pedidos en curso, pagos, etc.).</Text></ListaItem>
            <ListaItem><Text>Algunos datos pueden conservarse por obligaciones legales (ver Política de Privacidad).</Text></ListaItem>
            <ListaItem><Text>Saldos, créditos o cupones no utilizados pueden perderse según las políticas aplicables.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>5. Uso de la Plataforma</Heading>

            <Subtitle>5.1. Licencia de Uso</Subtitle>
            <Text>Kusina te otorga una licencia limitada, no exclusiva, no transferible, revocable y personal para acceder y usar la Plataforma exclusivamente para fines personales y no comerciales, conforme a estos Términos.</Text>

            <Subtitle>5.2. Uso Permitido</Subtitle>
            <Text>Puedes utilizar la Plataforma para:</Text>
            <Lista>
            <ListaItem><Text>Explorar restaurantes, menús y productos disponibles.</Text></ListaItem>
            <ListaItem><Text>Realizar pedidos de comida para consumo personal.</Text></ListaItem>
            <ListaItem><Text>Gestionar tu Cuenta y preferencias.</Text></ListaItem>
            <ListaItem><Text>Acceder a promociones, ofertas y programas de fidelización.</Text></ListaItem>
            <ListaItem><Text>Comunicarte con Restaurantes y soporte de Kusina sobre tus pedidos.</Text></ListaItem>
            <ListaItem><Text>Dejar reseñas y calificaciones de restaurantes y productos (de manera respetuosa y veraz).</Text></ListaItem>
            </Lista>

            <Subtitle>5.3. Uso Prohibido</Subtitle>
            <Text>Está estrictamente prohibido:</Text>

            <Subtitleh3>5.3.1. Actividades Ilegales o Fraudulentas</Subtitleh3>
            <Lista>
            <ListaItem><Text>Utilizar la Plataforma para fines ilegales, fraudulentos o no autorizados.</Text></ListaItem>
            <ListaItem><Text>Realizar pedidos con información de pago falsa, robada o no autorizada.</Text></ListaItem>
            <ListaItem><Text>Solicitar reembolsos o contracargos de forma fraudulenta.</Text></ListaItem>
            <ListaItem><Text>Aprovecharse de errores de precios o promociones de manera abusiva.</Text></ListaItem>
            <ListaItem><Text>Crear cuentas múltiples para abusar de descuentos, cupones o promociones.</Text></ListaItem>
            </Lista>

            <Subtitleh3>5.3.2. Abuso de la Plataforma</Subtitleh3>
            <Lista>
            <ListaItem><Text>Realizar ingeniería inversa, descompilar, desensamblar o intentar descubrir el código fuente de la aplicación.</Text></ListaItem>
            <ListaItem><Text>Utilizar bots, scripts, scraping, crawlers o cualquier medio automatizado para acceder o extraer información de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Interferir con el funcionamiento de la Plataforma o sus servidores.</Text></ListaItem>
            <ListaItem><Text>Intentar acceder a áreas restringidas o cuentas de otros usuarios.</Text></ListaItem>
            <ListaItem><Text>Realizar ataques cibernéticos (DDoS, phishing, hacking, etc.).</Text></ListaItem>
            <ListaItem><Text>Eludir medidas de seguridad, autenticación o restricciones de acceso.</Text></ListaItem>
            </Lista>

            <Subtitleh3>5.3.3. Uso Comercial No Autorizado</Subtitleh3>
            <Lista>
            <ListaItem><Text>Revender, redistribuir o comercializar productos o servicios obtenidos a través de Kusina sin autorización.</Text></ListaItem>
            <ListaItem><Text>Utilizar la Plataforma con fines comerciales o empresariales (para ello debe contactarse con Kusina para un acuerdo corporativo).</Text></ListaItem>
            <ListaItem><Text>Copiar, reproducir, distribuir o modificar el contenido de la Plataforma sin autorización.</Text></ListaItem>
            </Lista>

            <Subtitleh3>5.3.4. Conducta Inapropiada</Subtitleh3>
            <Lista>
            <ListaItem><Text>Acosar, amenazar, intimidar o abusar de Restaurantes, personal de Kusina u otros usuarios.</Text></ListaItem>
            <ListaItem><Text>Publicar contenido ofensivo, difamatorio, obsceno, discriminatorio o que incite al odio.</Text></ListaItem>
            <ListaItem><Text>Dejar reseñas falsas, maliciosas o con fines extorsivos.</Text></ListaItem>
            <ListaItem><Text>Utilizar lenguaje vulgar, obsceno o amenazante en comunicaciones.</Text></ListaItem>
            </Lista>

            <Subtitle>5.4. Consecuencias del Uso Indebido</Subtitle>
            <Text>El incumplimiento de estas restricciones puede resultar en:</Text>
            <Lista>
            <ListaItem><Text>Suspensión o cancelación inmediata de tu Cuenta.</Text></ListaItem>
            <ListaItem><Text>Bloqueo permanente de acceso a la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Retención de saldos, créditos o reembolsos pendientes.</Text></ListaItem>
            <ListaItem><Text>Acciones legales civiles o penales según corresponda.</Text></ListaItem>
            <ListaItem><Text>Reporte a autoridades competentes por actividades ilegales.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>6. Pedidos y Transacciones</Heading>

            <Subtitle>6.1. Proceso de Pedido</Subtitle>

            <Subtitleh3>6.1.1. Selección de Productos</Subtitleh3>
            <Lista>
            <ListaItem><Text>Explora los restaurantes disponibles en tu zona a través de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Selecciona los productos que deseas ordenar y agrégalos a tu carrito de compras.</Text></ListaItem>
            <ListaItem><Text>Verifica la descripción, precio, opciones de personalización (ingredientes adicionales, modificaciones, etc.).</Text></ListaItem>
            <ListaItem><Text>Revisa el costo total que incluye: precio de productos + tarifa de servicio + costo de entrega (si aplica) + impuestos.</Text></ListaItem>
            </Lista>

            <Subtitleh3>6.1.2. Información de Entrega</Subtitleh3>
            <Lista>
            <ListaItem><Text>Proporciona una dirección de entrega completa y precisa (calle, número, distrito, referencias).</Text></ListaItem>
            <ListaItem><Text>Asegúrate de que la dirección esté dentro del área de cobertura del Restaurante.</Text></ListaItem>
            <ListaItem><Text>Puedes agregar instrucciones especiales de entrega (por ejemplo: número de departamento, timbre, indicaciones de acceso).</Text></ListaItem>
            </Lista>

            <Subtitleh3>6.1.3. Confirmación y Pago</Subtitleh3>
            <Lista>
            <ListaItem><Text>Revisa cuidadosamente tu pedido antes de confirmar.</Text></ListaItem>
            <ListaItem><Text>Selecciona tu método de pago (tarjeta de crédito/débito, billeteras digitales, pago en efectivo si está disponible).</Text></ListaItem>
            <ListaItem><Text>Al confirmar el pedido, autorizas el cargo del monto total a tu método de pago.</Text></ListaItem>
            <ListaItem><Text>Recibirás una confirmación del pedido por correo electrónico y/o notificación en la aplicación.</Text></ListaItem>
            </Lista>

            <Subtitle>6.2. Aceptación del Pedido</Subtitle>
            <Text>Una vez realizado el pedido:</Text>
            <Lista>
            <ListaItem><Text>El Restaurante recibirá tu solicitud y decidirá si acepta o rechaza el pedido según su disponibilidad, capacidad y políticas.</Text></ListaItem>
            <ListaItem><Text>Si el pedido es <strong>aceptado</strong>, el Restaurante comenzará la preparación y se te notificará el tiempo estimado de entrega.</Text></ListaItem>
            <ListaItem><Text>Si el pedido es <strong>rechazado</strong> (por falta de disponibilidad, cierre del local, problemas técnicos, etc.), se te notificará y se procesará el reembolso completo automáticamente según el método de pago utilizado.</Text></ListaItem>
            </Lista>

            <Subtitle>6.3. Contrato Vinculante</Subtitle>
            <Text>Al confirmar un pedido:</Text>
            <Lista>
            <ListaItem><Text>Celebras un contrato de compra-venta con el Restaurante (no con Kusina).</Text></ListaItem>
            <ListaItem><Text>El contrato se perfecciona cuando el Restaurante acepta el pedido.</Text></ListaItem>
            <ListaItem><Text>Te comprometes a pagar el monto total del pedido.</Text></ListaItem>
            <ListaItem><Text>El Restaurante se compromete a preparar y entregar el pedido conforme a lo solicitado.</Text></ListaItem>
            </Lista>

            <Subtitle>6.4. Modificación y Cancelación de Pedidos</Subtitle>

            <Subtitleh3>6.4.1. Modificaciones</Subtitleh3>
            <Lista>
            <ListaItem><Text>Las modificaciones al pedido (cambio de productos, dirección, instrucciones) solo pueden realizarse <strong>antes de que el Restaurante acepte el pedido</strong>.</Text></ListaItem>
            <ListaItem><Text>Una vez aceptado, las modificaciones quedan sujetas a la discreción del Restaurante. Puedes contactar al Restaurante directamente a través de la Plataforma o al soporte de Kusina.</Text></ListaItem>
            </Lista>

            <Subtitleh3>6.4.2. Cancelación por el Usuario</Subtitleh3>
            <Text><strong>Antes de la aceptación del Restaurante:</strong></Text>
            <Lista>
            <ListaItem><Text>Puedes cancelar el pedido sin cargo desde la aplicación.</Text></ListaItem>
            <ListaItem><Text>Se procesará el reembolso completo automáticamente.</Text></ListaItem>
            </Lista>

            <Text><strong>Después de la aceptación del Restaurante:</strong></Text>
            <Lista>
            <ListaItem><Text>La cancelación está sujeta a la política del Restaurante.</Text></ListaItem>
            <ListaItem><Text>Si el Restaurante ya inició la preparación, es posible que no se permita la cancelación o que se aplique un cargo por cancelación.</Text></ListaItem>
            <ListaItem><Text>Debes solicitar la cancelación contactando al soporte de Kusina lo antes posible.</Text></ListaItem>
            <ListaItem><Text>Kusina mediará entre tú y el Restaurante para resolver la solicitud de cancelación de manera justa.</Text></ListaItem>
            </Lista>

            <Subtitleh3>6.4.3. Cancelación por el Restaurante</Subtitleh3>
            <Text>El Restaurante puede cancelar tu pedido en casos excepcionales como:</Text>
            <Lista>
            <ListaItem><Text>Falta de disponibilidad de productos después de haber aceptado el pedido.</Text></ListaItem>
            <ListaItem><Text>Problemas operativos, técnicos o de fuerza mayor.</Text></ListaItem>
            <ListaItem><Text>Dirección de entrega fuera del área de cobertura.</Text></ListaItem>
            <ListaItem><Text>Sospecha de fraude o información incorrecta.</Text></ListaItem>
            </Lista>
            <Text>En caso de cancelación por el Restaurante, recibirás un reembolso completo automáticamente.</Text>

            <Subtitle>6.5. Tiempos de Entrega</Subtitle>
            <Lista>
            <ListaItem><Text>Los tiempos de entrega mostrados en la Plataforma son <strong>estimados</strong> y proporcionados por el Restaurante.</Text></ListaItem>
            <ListaItem><Text>Los tiempos pueden variar debido a factores como: volumen de pedidos, condiciones climáticas, tráfico, disponibilidad del Restaurante, etc.</Text></ListaItem>
            <ListaItem><Text>Kusina y los Restaurantes harán los mejores esfuerzos para cumplir con los tiempos estimados, pero no garantizan entregas en tiempos exactos.</Text></ListaItem>
            <ListaItem><Text>Kusina no es responsable por retrasos causados por circunstancias fuera de su control.</Text></ListaItem>
            </Lista>

            <Subtitle>6.6. Recepción del Pedido</Subtitle>
            <Text>Al recibir tu pedido:</Text>
            <Lista>
            <ListaItem><Text>Verifica que el pedido esté completo y en buenas condiciones <strong>antes de aceptarlo</strong>.</Text></ListaItem>
            <ListaItem><Text>Si hay algún problema evidente (productos faltantes, derramados, dañados, incorrectos), repórtalo inmediatamente al personal de entrega y a Kusina a través de la aplicación.</Text></ListaItem>
            <ListaItem><Text>Una vez aceptado el pedido, se considera que lo recibiste conforme, salvo que reportes un problema dentro de los 15 minutos siguientes a la entrega.</Text></ListaItem>
            </Lista>

            <Subtitle>6.7. Disponibilidad de Productos y Precios</Subtitle>
            <Lista>
            <ListaItem><Text>La disponibilidad de productos y Restaurantes está sujeta a cambios sin previo aviso.</Text></ListaItem>
            <ListaItem><Text>Los precios son establecidos por cada Restaurante y pueden variar sin previo aviso.</Text></ListaItem>
            <ListaItem><Text>Kusina no garantiza la disponibilidad continua de productos, restaurantes o promociones.</Text></ListaItem>
            <ListaItem><Text>En caso de errores evidentes en los precios (por ejemplo, un plato de S/ 50 aparece a S/ 5), Kusina se reserva el derecho de cancelar el pedido y reembolsar el pago.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>7. Precios, Pagos y Facturación</Heading>

            <Subtitle>7.1. Composición del Precio Total</Subtitle>
            <Text>El precio total de tu pedido incluye:</Text>
            <Lista>
            <ListaItem><Text><strong>Precio de los productos:</strong> Establecido por el Restaurante para cada ítem del menú.</Text></ListaItem>
            <ListaItem><Text><strong>Tarifa de servicio de Kusina:</strong> Comisión cobrada por el uso de la Plataforma (varía según el pedido, puede ser un porcentaje o monto fijo).</Text></ListaItem>
            <ListaItem><Text><strong>Costo de entrega (si aplica):</strong> Monto por el servicio de delivery, que puede variar según distancia, Restaurante y condiciones del pedido. Algunos restaurantes ofrecen entrega gratuita según montos mínimos.</Text></ListaItem>
            <ListaItem><Text><strong>Impuestos aplicables:</strong> IGV (Impuesto General a las Ventas) del 18% según la legislación peruana, ya incluido en los precios mostrados.</Text></ListaItem>
            <ListaItem><Text><strong>Propinas (opcional):</strong> Puedes agregar una propina voluntaria para el personal del Restaurante o de entrega.</Text></ListaItem>
            </Lista>
            <Text>Todos los precios se muestran en <strong>Soles Peruanos (PEN / S/)</strong> e incluyen todos los impuestos aplicables.</Text>

            <Subtitle>7.2. Métodos de Pago Aceptados</Subtitle>
            <Text>Kusina acepta los siguientes métodos de pago:</Text>
            <Lista>
            <ListaItem><Text><strong>Tarjetas de crédito y débito:</strong> Visa, Mastercard, American Express, Diners Club.</Text></ListaItem>
            <ListaItem><Text><strong>Billeteras digitales:</strong> Yape, Plin, o las que Kusina habilite en el futuro.</Text></ListaItem>
            <ListaItem><Text><strong>Pago en efectivo contra entrega:</strong> Disponible solo en ciertos Restaurantes y zonas (sujeto a disponibilidad).</Text></ListaItem>
            <ListaItem><Text><strong>Transferencias bancarias o códigos QR:</strong> Según disponibilidad y acuerdos específicos.</Text></ListaItem>
            </Lista>

            <Subtitle>7.3. Procesamiento de Pagos</Subtitle>
            <Lista>
            <ListaItem><Text>Los pagos son procesados por proveedores de servicios de pago certificados que cumplen con los estándares de seguridad PCI-DSS.</Text></ListaItem>
            <ListaItem><Text>Kusina <strong>no almacena</strong> información completa de tarjetas de crédito/débito en sus servidores.</Text></ListaItem>
            <ListaItem><Text>Al confirmar un pedido, autorizas el cargo inmediato del monto total.</Text></ListaItem>
            <ListaItem><Text>Para pagos con tarjeta, se puede realizar una pre-autorización temporal que se convierte en cargo definitivo al aceptarse el pedido.</Text></ListaItem>
            </Lista>

            <Subtitle>7.4. Facturación y Comprobantes de Pago</Subtitle>
            <Lista>
            <ListaItem><Text>Por cada pedido, recibirás un <strong>comprobante de pago electrónico</strong> (boleta de venta) emitido por el Restaurante, conforme a la normativa de SUNAT.</Text></ListaItem>
            <ListaItem><Text>Si requieres <strong>factura electrónica</strong>, debes proporcionar tu RUC y razón social antes de confirmar el pedido. Las facturas no se pueden emitir después de generada la boleta.</Text></ListaItem>
            <ListaItem><Text>Los comprobantes electrónicos se envían al correo electrónico registrado en tu Cuenta y están disponibles en el historial de pedidos de la aplicación.</Text></ListaItem>
            <ListaItem><Text>Kusina emitirá comprobantes separados por la tarifa de servicio cuando aplique según la normativa tributaria.</Text></ListaItem>
            </Lista>

            <Subtitle>7.5. Descuentos, Cupones y Promociones</Subtitle>
            <Lista>
            <ListaItem><Text>Kusina puede ofrecer descuentos, cupones, códigos promocionales y programas de fidelización.</Text></ListaItem>
            <ListaItem><Text>Cada promoción tiene términos y condiciones específicos (vigencia, monto mínimo, restaurantes aplicables, límite de usos, etc.).</Text></ListaItem>
            <ListaItem><Text>Los cupones y descuentos <strong>no son acumulables</strong> salvo indicación expresa.</Text></ListaItem>
            <ListaItem><Text>Kusina se reserva el derecho de modificar, suspender o cancelar promociones en cualquier momento.</Text></ListaItem>
            <ListaItem><Text>El uso indebido de cupones (cuentas múltiples, fraude, abuso) puede resultar en la cancelación de beneficios y suspensión de la Cuenta.</Text></ListaItem>
            <ListaItem><Text>Los cupones y créditos promocionales no son canjeables por dinero en efectivo.</Text></ListaItem>
            </Lista>

            <Subtitle>7.6. Política de Reembolsos</Subtitle>
            <Text>Los reembolsos se procesarán en los siguientes casos:</Text>

            <Subtitleh3>7.6.1. Reembolso Completo Automático</Subtitleh3>
            <Lista>
            <ListaItem><Text>Pedido cancelado antes de la aceptación del Restaurante.</Text></ListaItem>
            <ListaItem><Text>Pedido rechazado por el Restaurante.</Text></ListaItem>
            <ListaItem><Text>Pedido cancelado por el Restaurante después de la aceptación (por causas imputables al Restaurante).</Text></ListaItem>
            <ListaItem><Text>Cargo duplicado o error en el cobro.</Text></ListaItem>
            </Lista>

            <Subtitleh3>7.6.2. Reembolso Parcial o Total por Reclamos</Subtitleh3>
            <Lista>
            <ListaItem><Text>Productos faltantes, incorrectos o en mal estado (sujeto a evaluación y evidencia fotográfica).</Text></ListaItem>
            <ListaItem><Text>Calidad deficiente de los alimentos que no cumple con estándares razonables.</Text></ListaItem>
            <ListaItem><Text>Retrasos excesivos no justificados en la entrega (evaluados caso por caso).</Text></ListaItem>
            </Lista>

            <Subtitleh3>7.6.3. Plazos de Reembolso</Subtitleh3>
            <Lista>
            <ListaItem><Text><strong>Pago con tarjeta:</strong> El reembolso se procesa en 24-48 horas, pero puede tardar de 5 a 15 días hábiles en reflejarse en tu estado de cuenta según tu entidad bancaria.</Text></ListaItem>
            <ListaItem><Text><strong>Billeteras digitales:</strong> Reembolso en 24-72 horas.</Text></ListaItem>
            <ListaItem><Text><strong>Pago en efectivo:</strong> Reembolso mediante crédito en tu Cuenta de Kusina para futuros pedidos, o transferencia bancaria según tu preferencia.</Text></ListaItem>
            </Lista>

            <Subtitleh3>7.6.4. Situaciones Sin Derecho a Reembolso</Subtitleh3>
            <Lista>
            <ListaItem><Text>Cambios de opinión después de recibir el pedido conforme.</Text></ListaItem>
            <ListaItem><Text>Preferencias personales de sabor no indicadas al momento del pedido.</Text></ListaItem>
            <ListaItem><Text>Problemas causados por información incorrecta proporcionada por el Usuario (dirección errónea, teléfono incorrecto, etc.).</Text></ListaItem>
            <ListaItem><Text>Retrasos por causas de fuerza mayor (desastres naturales, protestas, estado de emergencia, etc.).</Text></ListaItem>
            </Lista>

            <Subtitle>7.7. Contracargos (Chargebacks)</Subtitle>
            <Lista>
            <ListaItem><Text>Antes de solicitar un contracargo a tu banco, <strong>debes contactar primero al soporte de Kusina</strong> para resolver el problema.</Text></ListaItem>
            <ListaItem><Text>Los contracargos fraudulentos o injustificados pueden resultar en la suspensión permanente de tu Cuenta y acciones legales.</Text></ListaItem>
            <ListaItem><Text>Kusina se reserva el derecho de disputar contracargos cuando exista evidencia de que el servicio fue prestado conforme.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>8. Reclamos, Garantías y Atención al Cliente</Heading>

            <Subtitle>8.1. Canales de Atención</Subtitle>
            <Text>Si tienes algún problema con tu pedido o servicio, puedes contactarnos a través de:</Text>
            <Lista>
            <ListaItem><Text><strong>Chat en vivo:</strong> Disponible en la aplicación durante el horario de atención.</Text></ListaItem>
            <ListaItem><Text><strong>Correo electrónico:</strong> soporte@kusina.site</Text></ListaItem>
            <ListaItem><Text><strong>Teléfono:</strong> +51 973 834 813 (Lunes a Viernes de 9:00 AM a 6:00 PM)</Text></ListaItem>
            <ListaItem><Text><strong>Formulario de reclamos:</strong> Disponible en la sección "Ayuda" de la aplicación.</Text></ListaItem>
            </Lista>

            <Subtitle>8.2. Procedimiento de Reclamos</Subtitle>
            <Text><strong>Paso 1: Reportar el problema</strong></Text>
            <Lista>
            <ListaItem><Text>Reporta el problema <strong>inmediatamente</strong> al recibir el pedido o dentro de las <strong>2 horas</strong> siguientes a la entrega.</Text></ListaItem>
            <ListaItem><Text>Proporciona detalles específicos del problema (productos faltantes, incorrectos, derramados, calidad deficiente, etc.).</Text></ListaItem>
            <ListaItem><Text>Adjunta <strong>fotografías claras</strong> que evidencien el problema (del empaque, productos afectados, etc.).</Text></ListaItem>
            </Lista>

            <Text><strong>Paso 2: Evaluación</strong></Text>
            <Lista>
            <ListaItem><Text>Kusina revisará tu reclamo y podrá solicitar información adicional.</Text></ListaItem>
            <ListaItem><Text>Se contactará al Restaurante para verificar la situación.</Text></ListaItem>
            <ListaItem><Text>El tiempo de evaluación es de 24 a 72 horas hábiles según la complejidad del caso.</Text></ListaItem>
            </Lista>

            <Text><strong>Paso 3: Resolución</strong></Text>
            <Text>Según el caso, la resolución puede incluir:</Text>
            <Lista>
            <ListaItem><Text><strong>Reembolso total o parcial</strong> del monto del pedido.</Text></ListaItem>
            <ListaItem><Text><strong>Crédito en tu Cuenta</strong> para futuros pedidos.</Text></ListaItem>
            <ListaItem><Text><strong>Cupón de descuento</strong> como compensación.</Text></ListaItem>
            <ListaItem><Text><strong>Reenvío del pedido</strong> (en casos excepcionales y sujeto a disponibilidad del Restaurante).</Text></ListaItem>
            <ListaItem><Text>En algunos casos, se puede determinar que <strong>no procede</strong> el reclamo si no hay evidencia suficiente o si el problema no es imputable al Restaurante o Kusina.</Text></ListaItem>
            </Lista>

            <Subtitle>8.3. Garantía de Calidad</Subtitle>
            <Text>Kusina trabaja con Restaurantes que cumplen con estándares de calidad e higiene. Sin embargo:</Text>
            <Lista>
            <ListaItem><Text>La calidad de los alimentos es responsabilidad del Restaurante.</Text></ListaItem>
            <ListaItem><Text>Kusina actúa como intermediario y facilitador de reclamos, pero no garantiza la calidad específica de los productos.</Text></ListaItem>
            <ListaItem><Text>Los Usuarios deben reportar problemas de inmediato para que Kusina pueda mediar efectivamente.</Text></ListaItem>
            </Lista>

            <Subtitle>8.4. Libro de Reclamaciones Virtual</Subtitle>
            <Text>Conforme al Código de Protección y Defensa del Consumidor (Ley N° 29571), Kusina pone a disposición un <strong>Libro de Reclamaciones Virtual</strong> accesible desde:</Text>
            <Lista>
            <ListaItem><Text>La sección "Libro de Reclamaciones" en la aplicación.</Text></ListaItem>
            <ListaItem><Text>El sitio web de Kusina.</Text></ListaItem>
            <ListaItem><Text>Solicitándolo por correo a soporte@kusina.site</Text></ListaItem>
            </Lista>

            <Text><strong>Plazo de respuesta:</strong> Kusina responderá a tu reclamo dentro de los <strong>15 días calendario</strong> posteriores a su presentación, conforme a la normativa del INDECOPI.</Text>

            <Subtitle>8.5. Autoridades de Protección al Consumidor</Subtitle>
            <Text>Si no estás satisfecho con la respuesta de Kusina, puedes presentar tu reclamo ante:</Text>
            <Lista>
            <ListaItem><Text><strong>INDECOPI (Instituto Nacional de Defensa de la Competencia y de la Protección de la Propiedad Intelectual)</strong></Text></ListaItem>
            <ListaItem><Text>Plataforma SAC (Servicio de Atención al Ciudadano): https://servicios.indecopi.gob.pe</Text></ListaItem>
            <ListaItem><Text>Teléfono: (01) 224-7777 (Lima) / 0800-4-4040 (provincias)</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>9. Propiedad Intelectual</Heading>

            <Subtitle>9.1. Derechos de Kusina</Subtitle>
            <Text>Todo el contenido de la Plataforma, incluyendo pero no limitándose a:</Text>
            <Lista>
            <ListaItem><Text>Diseño, interfaz, gráficos, logos, iconos</Text></ListaItem>
            <ListaItem><Text>Textos, fotografías, videos, ilustraciones</Text></ListaItem>
            <ListaItem><Text>Software, código fuente, algoritmos</Text></ListaItem>
            <ListaItem><Text>Bases de datos, compilaciones de información</Text></ListaItem>
            <ListaItem><Text>Marcas comerciales: "Kusina", "Kusina App" y logos asociados</Text></ListaItem>
            </Lista>
            <Text>Son propiedad exclusiva de KUSINA APP E.I.R.L. o de sus licenciantes, y están protegidos por las leyes de propiedad intelectual de Perú y tratados internacionales.</Text>

            <Subtitle>9.2. Uso Restringido</Subtitle>
            <Text>No puedes, sin autorización previa y por escrito de Kusina:</Text>
            <Lista>
            <ListaItem><Text>Copiar, reproducir, distribuir, modificar o crear obras derivadas del contenido de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Usar las marcas, logos o nombres comerciales de Kusina.</Text></ListaItem>
            <ListaItem><Text>Descompilar, realizar ingeniería inversa o intentar extraer el código fuente de la aplicación.</Text></ListaItem>
            <ListaItem><Text>Eliminar, alterar u ocultar avisos de derechos de autor, marcas o propiedad intelectual.</Text></ListaItem>
            </Lista>

            <Subtitle>9.3. Contenido de Restaurantes</Subtitle>
            <Lista>
            <ListaItem><Text>Las fotografías, descripciones y contenido de los menús son proporcionados por los Restaurantes y son de su propiedad o tienen licencia para usarlos.</Text></ListaItem>
            <ListaItem><Text>Kusina no reclama propiedad sobre el contenido de terceros, pero tiene licencia para mostrarlo en la Plataforma.</Text></ListaItem>
            </Lista>

            <Subtitle>9.4. Contenido Generado por Usuarios</Subtitle>
            <Text>Al publicar reseñas, calificaciones, comentarios o cualquier contenido en la Plataforma:</Text>
            <Lista>
            <ListaItem><Text>Otorgas a Kusina una licencia mundial, no exclusiva, libre de regalías, transferible y sublicenciable para usar, reproducir, distribuir, mostrar y modificar dicho contenido en relación con la operación de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Declaras que tienes todos los derechos necesarios sobre el contenido que publicas.</Text></ListaItem>
            <ListaItem><Text>El contenido debe ser veraz, respetuoso y no infringir derechos de terceros.</Text></ListaItem>
            <ListaItem><Text>Kusina se reserva el derecho de eliminar contenido inapropiado, ofensivo, difamatorio o que viole estos Términos.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>10. Limitación de Responsabilidad y Exención de Garantías</Heading>

            <Subtitle>10.1. Servicio "TAL CUAL"</Subtitle>
            <Text>La Plataforma se proporciona "TAL CUAL" y "SEGÚN DISPONIBILIDAD", sin garantías de ningún tipo, expresas o implícitas, incluyendo pero no limitándose a:</Text>
            <Lista>
            <ListaItem><Text>Disponibilidad ininterrumpida, segura o libre de errores.</Text></ListaItem>
            <ListaItem><Text>Exactitud, confiabilidad o actualidad de la información.</Text></ListaItem>
            <ListaItem><Text>Resultados específicos o satisfacción con el servicio.</Text></ListaItem>
            <ListaItem><Text>Calidad específica de los productos de los Restaurantes.</Text></ListaItem>
            </Lista>

            <Subtitle>10.2. Responsabilidades de Terceros</Subtitle>
            <Text>Kusina <strong>NO es responsable</strong> por:</Text>

            <Subtitleh3>10.2.1. Actuación de Restaurantes</Subtitleh3>
            <Lista>
            <ListaItem><Text>Calidad, higiene, seguridad o preparación de los alimentos.</Text></ListaItem>
            <ListaItem><Text>Precisión de las descripciones de productos, ingredientes, alérgenos o información nutricional.</Text></ListaItem>
            <ListaItem><Text>Enfermedades transmitidas por alimentos, alergias, intoxicaciones o reacciones adversas.</Text></ListaItem>
            <ListaItem><Text>Incumplimiento de normativas sanitarias, permisos de funcionamiento o licencias.</Text></ListaItem>
            <ListaItem><Text>Retrasos en la preparación o entrega imputables al Restaurante.</Text></ListaItem>
            <ListaItem><Text>Cancelaciones, cierres temporales o permanentes de Restaurantes.</Text></ListaItem>
            </Lista>

            <Subtitleh3>10.2.2. Situaciones Fuera de Control</Subtitleh3>
            <Lista>
            <ListaItem><Text>Fallas en servicios de terceros (procesadores de pago, servicios de hosting, internet, etc.).</Text></ListaItem>
            <ListaItem><Text>Caso fortuito o fuerza mayor (desastres naturales, pandemias, estados de emergencia, protestas, cortes de energía, etc.).</Text></ListaItem>
            <ListaItem><Text>Acciones de autoridades gubernamentales (restricciones sanitarias, toques de queda, etc.).</Text></ListaItem>
            <ListaItem><Text>Problemas en la infraestructura de internet o telecomunicaciones.</Text></ListaItem>
            </Lista>

            <Subtitleh3>10.2.3. Uso Indebido por el Usuario</Subtitleh3>
            <Lista>
            <ListaItem><Text>Pérdidas derivadas del uso inadecuado de la Plataforma o violación de estos Términos.</Text></ListaItem>
            <ListaItem><Text>Acceso no autorizado a tu Cuenta por negligencia en proteger tus credenciales.</Text></ListaItem>
            <ListaItem><Text>Información incorrecta o incompleta proporcionada por el Usuario (dirección errónea, teléfono incorrecto, etc.).</Text></ListaItem>
            </Lista>

            <Subtitle>10.3. Limitación de Daños</Subtitle>
            <Text>En la máxima medida permitida por la ley peruana:</Text>
            <Lista>
            <ListaItem><Text>Kusina, sus directores, empleados, afiliados y proveedores <strong>NO serán responsables</strong> por daños indirectos, incidentales, especiales, consecuentes o punitivos, incluyendo pero no limitándose a pérdida de beneficios, datos, uso, goodwill u otras pérdidas intangibles.</Text></ListaItem>
            <ListaItem><Text>La responsabilidad total de Kusina en cualquier caso <strong>no excederá</strong> el monto pagado por el Usuario en el pedido específico que dio origen al reclamo, o S/ 100.00 (cien soles), lo que sea menor.</Text></ListaItem>
            </Lista>

            <Subtitle>10.4. Indemnización</Subtitle>
            <Text>Aceptas indemnizar, defender y mantener indemne a Kusina, sus directores, empleados, afiliados y proveedores de cualquier reclamo, pérdida, responsabilidad, daño, costo o gasto (incluyendo honorarios legales razonables) que surja de:</Text>
            <Lista>
            <ListaItem><Text>Tu uso indebido de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Violación de estos Términos y Condiciones.</Text></ListaItem>
            <ListaItem><Text>Violación de derechos de terceros, incluyendo Restaurantes, otros usuarios o cualquier otra parte.</Text></ListaItem>
            <ListaItem><Text>Información falsa o engañosa proporcionada por ti.</Text></ListaItem>
            </Lista>

            <Subtitle>10.5. Exclusiones según Ley del Consumidor</Subtitle>
            <Text>Nada en estos Términos excluye o limita la responsabilidad de Kusina por:</Text>
            <Lista>
            <ListaItem><Text>Muerte o lesiones personales causadas por negligencia grave o dolo de Kusina.</Text></ListaItem>
            <ListaItem><Text>Fraude o declaraciones fraudulentas.</Text></ListaItem>
            <ListaItem><Text>Derechos que no pueden ser excluidos o limitados según el Código de Protección y Defensa del Consumidor u otras leyes imperativas de Perú.</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>11. Privacidad y Protección de Datos Personales</Heading>

            <Subtitle>11.1. Política de Privacidad</Subtitle>
            <Text>El tratamiento de tus datos personales se rige por nuestra <strong>Política de Privacidad para Usuarios</strong>, que forma parte integral de estos Términos y Condiciones.</Text>
            <Text>Te recomendamos leer detenidamente nuestra Política de Privacidad disponible en la aplicación y en nuestro sitio web.</Text>

            <Subtitle>11.2. Consentimiento</Subtitle>
            <Text>Al aceptar estos Términos, también aceptas nuestra Política de Privacidad y consientes el tratamiento de tus datos personales conforme a la misma.</Text>

            <Subtitle>11.3. Tus Derechos ARCO</Subtitle>
            <Text>Conforme a la Ley N° 29733, tienes derecho a:</Text>
            <Lista>
            <ListaItem><Text><strong>Acceso:</strong> Conocer qué datos personales tuyos tratamos.</Text></ListaItem>
            <ListaItem><Text><strong>Rectificación:</strong> Corregir datos inexactos o incompletos.</Text></ListaItem>
            <ListaItem><Text><strong>Cancelación:</strong> Solicitar la eliminación de tus datos (salvo obligaciones legales de conservación).</Text></ListaItem>
            <ListaItem><Text><strong>Oposición:</strong> Oponerte al tratamiento de tus datos para ciertos fines (marketing, por ejemplo).</Text></ListaItem>
            </Lista>
            <Text>Para ejercer estos derechos, contacta a soporte@kusina.site</Text>

            <Subtitle>11.4. Seguridad de la Información</Subtitle>
            <Text>Kusina implementa medidas técnicas, organizativas y legales para proteger tus datos personales contra acceso no autorizado, pérdida o alteración. Sin embargo, ninguna transmisión por internet es 100% segura. Consulta nuestra Política de Privacidad para más detalles.</Text>
          </TermsSection>

          <TermsSection>
            <Heading>12. Modificaciones a los Términos y Condiciones</Heading>

            <Subtitle>12.1. Derecho a Modificar</Subtitle>
            <Text>Kusina se reserva el derecho de modificar, actualizar o reemplazar estos Términos y Condiciones en cualquier momento, a su exclusiva discreción, para:</Text>
            <Lista>
            <ListaItem><Text>Reflejar cambios en la legislación aplicable.</Text></ListaItem>
            <ListaItem><Text>Incorporar nuevas funcionalidades o servicios.</Text></ListaItem>
            <ListaItem><Text>Mejorar la seguridad, claridad o transparencia de los términos.</Text></ListaItem>
            <ListaItem><Text>Adaptarse a cambios en el modelo de negocio o políticas internas.</Text></ListaItem>
            </Lista>

            <Subtitle>12.2. Notificación de Cambios</Subtitle>
            <Text>Cuando realicemos cambios significativos a estos Términos:</Text>
            <Lista>
            <ListaItem><Text>Actualizaremos la fecha de "Última actualización" en la parte superior de este documento.</Text></ListaItem>
            <ListaItem><Text>Te notificaremos mediante correo electrónico, notificación push en la aplicación o aviso destacado al iniciar sesión.</Text></ListaItem>
            <ListaItem><Text>Te daremos un plazo razonable (generalmente 15 días) antes de que los cambios entren en vigencia.</Text></ListaItem>
            </Lista>

            <Subtitle>12.3. Aceptación de Cambios</Subtitle>
            <Lista>
            <ListaItem><Text>Si continúas utilizando la Plataforma después de la entrada en vigencia de los cambios, se entenderá que aceptas los Términos modificados.</Text></ListaItem>
            <ListaItem><Text>Si no estás de acuerdo con los cambios, puedes dejar de usar la Plataforma y solicitar la cancelación de tu Cuenta antes de que los cambios entren en vigencia.</Text></ListaItem>
            </Lista>

            <Subtitle>12.4. Versiones Anteriores</Subtitle>
            <Text>Puedes solicitar acceso a versiones anteriores de estos Términos contactando a soporte@kusina.site. Conservamos el historial de cambios para tu referencia.</Text>
          </TermsSection>

          <TermsSection>
            <Heading>13. Rescisión y Terminación</Heading>

            <Subtitle>13.1. Terminación por el Usuario</Subtitle>
            <Text>Puedes dejar de usar la Plataforma y solicitar la cancelación de tu Cuenta en cualquier momento desde la configuración de la aplicación o contactando a soporte@kusina.site.</Text>

            <Subtitle>13.2. Terminación por Kusina</Subtitle>
            <Text>Kusina puede suspender o cancelar tu acceso a la Plataforma, inmediatamente y sin previo aviso, en caso de:</Text>
            <Lista>
            <ListaItem><Text>Violación de estos Términos y Condiciones.</Text></ListaItem>
            <ListaItem><Text>Actividades fraudulentas, ilegales o que perjudiquen a Kusina, Restaurantes u otros usuarios.</Text></ListaItem>
            <ListaItem><Text>Sospecha razonable de uso indebido o abuso de la Plataforma.</Text></ListaItem>
            <ListaItem><Text>Impago de obligaciones o contracargos fraudulentos.</Text></ListaItem>
            <ListaItem><Text>Inactividad prolongada (más de 24 meses).</Text></ListaItem>
            <ListaItem><Text>Requerimiento legal o de autoridad competente.</Text></ListaItem>
            </Lista>

            <Subtitle>13.3. Efectos de la Terminación</Subtitle>
            <Text>Al terminar tu Cuenta:</Text>
            <Lista>
            <ListaItem><Text>Perderás acceso a la Plataforma y a tu historial de pedidos.</Text></ListaItem>
            <ListaItem><Text>Se cancelarán cupones, créditos o beneficios no utilizados (salvo disposición legal en contrario).</Text></ListaItem>
            <ListaItem><Text>Deberás cumplir con obligaciones pendientes (pedidos en curso, pagos adeudados, etc.).</Text></ListaItem>
            <ListaItem><Text>Tus datos personales se tratarán conforme a nuestra Política de Privacidad (conservación por obligaciones legales, etc.).</Text></ListaItem>
            </Lista>

            <Subtitle>13.4. Supervivencia de Cláusulas</Subtitle>
            <Text>Las siguientes cláusulas sobrevivirán a la terminación de estos Términos: Propiedad Intelectual, Limitación de Responsabilidad, Indemnización, Privacidad, Ley Aplicable y Resolución de Disputas.</Text>
          </TermsSection>

          <TermsSection>
            <Heading>14. Disposiciones Generales</Heading>

            <Subtitle>14.1. Ley Aplicable y Jurisdicción</Subtitle>
            <Lista>
            <ListaItem><Text>Estos Términos y Condiciones se rigen e interpretan de acuerdo con las leyes de la República del Perú.</Text></ListaItem>
            <ListaItem><Text>Cualquier controversia derivada de estos Términos se someterá a la jurisdicción exclusiva de los jueces y tribunales de Lima, Perú.</Text></ListaItem>
            <ListaItem><Text>Sin perjuicio de lo anterior, los consumidores pueden acudir a las autoridades de protección al consumidor (INDECOPI) para resolver disputas.</Text></ListaItem>
            </Lista>

            <Subtitle>14.2. Resolución de Disputas</Subtitle>
            <Text><strong>Negociación Directa:</strong></Text>
            <Lista>
            <ListaItem><Text>Ante cualquier controversia, las partes intentarán resolverla de buena fe mediante negociación directa contactando a soporte@kusina.site</Text></ListaItem>
            </Lista>

            <Text><strong>Mediación y Conciliación:</strong></Text>
            <Lista>
            <ListaItem><Text>Si la negociación directa no resuelve la disputa, las partes pueden acudir a centros de conciliación autorizados en Perú antes de iniciar acciones judiciales.</Text></ListaItem>
            </Lista>

            <Text><strong>INDECOPI:</strong></Text>
            <Lista>
            <ListaItem><Text>Los consumidores pueden presentar reclamos ante INDECOPI conforme al Código de Protección y Defensa del Consumidor.</Text></ListaItem>
            </Lista>

            <Subtitle>14.3. Separabilidad</Subtitle>
            <Text>Si alguna disposición de estos Términos es declarada inválida, ilegal o inaplicable por autoridad competente, dicha disposición se modificará e interpretará para cumplir los objetivos en la máxima medida posible, y las demás disposiciones continuarán en pleno vigor y efecto.</Text>

            <Subtitle>14.4. Renuncia</Subtitle>
            <Text>La falta de ejercicio o demora en ejercer cualquier derecho o disposición de estos Términos por parte de Kusina no constituye una renuncia a dicho derecho o disposición.</Text>

            <Subtitle>14.5. Acuerdo Completo</Subtitle>
            <Text>Estos Términos y Condiciones, junto con la Política de Privacidad y cualquier política específica publicada en la Plataforma, constituyen el acuerdo completo entre tú y Kusina con respecto al uso de la Plataforma, y reemplazan todos los acuerdos anteriores o contemporáneos, escritos u orales.</Text>

            <Subtitle>14.6. Cesión</Subtitle>
            <Lista>
            <ListaItem><Text>No puedes ceder, transferir o sublicenciar tus derechos u obligaciones bajo estos Términos sin el consentimiento previo por escrito de Kusina.</Text></ListaItem>
            <ListaItem><Text>Kusina puede ceder o transferir estos Términos, en su totalidad o en parte, sin restricciones, especialmente en caso de fusión, adquisición o venta de activos.</Text></ListaItem>
            </Lista>

            <Subtitle>14.7. Idioma</Subtitle>
            <Text>Estos Términos están redactados en idioma español. En caso de traducciones a otros idiomas, prevalecerá la versión en español.</Text>

            <Subtitle>14.8. Títulos</Subtitle>
            <Text>Los títulos y subtítulos utilizados en estos Términos son solo para referencia y no afectan la interpretación de las cláusulas.</Text>

            <Subtitle>14.9. Contacto Legal</Subtitle>
            <Text>Para notificaciones legales, comunicaciones formales o consultas sobre estos Términos:</Text>
            <Lista>
            <ListaItem><Text><strong>Razón Social:</strong> KUSINA APP E.I.R.L.</Text></ListaItem>
            <ListaItem><Text><strong>Domicilio Legal:</strong> Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro</Text></ListaItem>
            <ListaItem><Text><strong>Correo Legal:</strong> soporte@kusina.site (Asunto: "Notificación Legal")</Text></ListaItem>
            </Lista>
          </TermsSection>

          <TermsSection>
            <Heading>15. Aceptación de los Términos</Heading>

            <Text>Al hacer clic en "Aceptar", "Registrarme", "Crear Cuenta", descargar la aplicación o utilizar la Plataforma de cualquier manera, reconoces y aceptas que:</Text>
            <Lista>
            <ListaItem><Text>Has leído y comprendido estos Términos y Condiciones en su totalidad.</Text></ListaItem>
            <ListaItem><Text>Has leído y aceptado nuestra Política de Privacidad.</Text></ListaItem>
            <ListaItem><Text>Eres mayor de 18 años o cuentas con autorización de tus padres/tutores.</Text></ListaItem>
            <ListaItem><Text>Tienes capacidad legal para celebrar contratos vinculantes.</Text></ListaItem>
            <ListaItem><Text>Toda la información que proporcionas es veraz, exacta y actualizada.</Text></ListaItem>
            <ListaItem><Text>Te comprometes a cumplir con estos Términos y todas las leyes aplicables.</Text></ListaItem>
            <ListaItem><Text>Comprendes que Kusina es un intermediario tecnológico y no un restaurante o servicio de delivery propio.</Text></ListaItem>
            <ListaItem><Text>Aceptas las limitaciones de responsabilidad y garantías establecidas en estos Términos.</Text></ListaItem>
            </Lista>

            <Text><strong>Si no estás de acuerdo con estos Términos y Condiciones, no debes utilizar la Plataforma Kusina.</strong></Text>
          </TermsSection>

          <TermsSection>
            <Heading>¡Gracias por Elegir Kusina!</Heading>
            <Text>En Kusina trabajamos cada día para conectarte con los mejores restaurantes de tu ciudad y brindarte una experiencia excepcional. Valoramos tu confianza y estamos comprometidos con tu satisfacción.</Text>
            <Text>Si tienes preguntas, comentarios o necesitas asistencia, nuestro equipo de soporte está aquí para ayudarte.</Text>

            <Subtitle style={{marginTop: '30px'}}><strong>KUSINA APP E.I.R.L.</strong></Subtitle>
            <Text><strong>RUC:</strong> 20613753983</Text>
            <Text><strong>Domicilio:</strong> Av. Javier Padro Este Nro. 560 Int. 1302, Lima, Lima, San Isidro</Text>
            <Text><strong>Email:</strong> soporte@kusina.site</Text>
            <Text><strong>Teléfono:</strong> +51 973 834 813</Text>
            <Text><strong>Horario de atención:</strong> Lunes a Viernes de 9:00 AM a 6:00 PM</Text>
            <Text><strong>Última actualización:</strong> 16 de diciembre de 2025</Text>

            <Text style={{marginTop: '20px', fontStyle: 'italic'}}>Estos Términos y Condiciones están disponibles permanentemente en la aplicación Kusina y en nuestro sitio web para tu consulta.</Text>
          </TermsSection>

        </Container>
      </TermsSec>
    </>
  )
}

export default TermsAndConditionsUsuarios
